var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"icon":"error","title":"充值失败","subTitle":""}},[_c('template',{slot:"extra"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }